import axios, { AxiosPromise } from 'axios';

import { AdvancedFilterItem } from '../src/type/AdvancedFilters';

export const advancedSearch = (
  isUrbano: boolean,
  filtros: AdvancedFilterItem[],
  page: number = 0,
  size: number = 10
): AxiosPromise<any> =>
  axios.post(
    isUrbano ? '/api/imoveis/advanced-search' : '/api/rural/advanced-search',
    filtros,
    { params: { page, size } }
  );
